Ext.define('SA.CrosstabRequestAttributes', {
    constructor({top, left}) {
        this.top = top.slice();
        this.left = left.slice();
    },

    filterIds(filterIds) {
        this.top = this.top.filter(top => {
            var columnIds = this.left.map(left => SA.CrosstabDataId.get([top, left]));

            return Ext.Array.difference(columnIds, filterIds).length > 0;
        });

        this.left = this.left.filter(left => {
            var rowIds = this.top.map(top => SA.CrosstabDataId.get([top, left]));

            return Ext.Array.difference(rowIds, filterIds).length > 0;
        });
    },

    filterLists(lists) {
        Array.from(lists).forEach(list => this.filterIds(list.getIds()));
    },

    getBatches(maxPerSidePerRequest) {
        var topBatches = SA.Array.divide(this.top, maxPerSidePerRequest),
            leftBatches = SA.Array.divide(this.left, maxPerSidePerRequest);

        return SA.Array.flatMap(topBatches, top => leftBatches.map(left => ({top, left})));
    },

    getIds() {
        return SA.Array.flatMap(this.top, top => this.left.map(left => SA.CrosstabDataId.get([top, left])));
    },

    isEmpty() {
        return this.top.length === 0; 
    }
});